import React, { useState } from 'react'
import Select from 'react-select'
import { Checkbox, Drawer } from 'antd'

import { usePet, useToggle, useListData } from '../../modules'
import { accountTypes } from '../../data'
import SelectLabel from '../reusable/selectLabel'

const NewAccount = ({ toggle, visible, onPerform }) => {
    const [name, setName] = useState()
    const [accType, setAccType] = useState()
    const [parent, setParent] = useState()
    const [desc, setDesc] = useState()
    const [string, setString] = useState()

    const [sub, toggleSub] = useToggle()

    const close = () => {
        toggle()
    }

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'desc':
                setDesc(e.target.value)
                break

            default:
                break
        }
    }
    
    const [
        { loading: accLoading, fetch }, 
        { list: accounts = [] }, 
        { navigate }
    ] = useListData('accounts', { haParent: false, string }, { notify: true, manual: false }, 'accounts', 100)

    const search = str => {
        if (str?.length === 0 || str?.length >= 2) {
            setString(str)
            navigate(1)
            fetch()
        }
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Account has been added', ops('success'))
        
        setTimeout(close, 300)
    }

    const [{ loading }, execute] = usePet('newAccount', {
        name,
        type: accType?.value,
        parent: parent?.value,
        desc
    }, { notify: true, callback: onComplete, manual: true })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={execute} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Create Account</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">New Account</p>
            <div className="flex flex-wrap mt-3">
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Account Name
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-name"
                        name="name"
                        value={name}
                        onChange={modify}
                        type="text"
                        placeholder="Account Name" />
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                        Account Type
                    </label>
                    <Select
                        isClearable
                        className="mb-3"
                        value={ accType }
                        isDisabled={ parent }
                        onChange={ setAccType }
                        options={ accountTypes }
                        formatGroupLabel={ SelectLabel }
                        placeholder="Search for Account type"
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }} />
                </div>
                <div className="w-full px-3 mb-2">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" htmlFor="grid-username">
                        Sub Account
                    </label>
                    <Checkbox className="mb-2" checked={ sub } onChange={ () => {
                        if (sub)
                            setParent()
                        toggleSub()
                    } }>Add as Sub-Account</Checkbox>                
                    {
                        sub &&
                        <Select
                            className="my-3"
                            isClearable
                            value={ parent }
                            onInputChange={ search }
                            isLoading={ accLoading }
                            onChange={ val => {
                                setParent(val)
                                if (val)
                                    setAccType({ label: val?.type, value: val?.type })
                            }}
                            options={accounts.map(acc => ({ label: acc.name, type: acc.type, value: acc._id }))}
                            placeholder="Select account parent" />
                    }
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Account Description
                    </label>
                    <textarea
                        rows={ 4 }
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-desc"
                        name="desc"
                        value={desc}
                        onChange={modify}
                        type="text"
                        placeholder="Account Description" />
                </div>
            </div>
        </Drawer>
    )
}

export default NewAccount